import type { Query, QueryKey } from '@tanstack/react-query';
import { matchQuery } from '@tanstack/react-query';

/**
 * `placeholderData` that holds the previous query's data while the key changes, but only when the
 * previous key starts with `keyPrefix` — so data never carries over to a different entity.
 *
 * @param keyPrefix leading key parts that must match for the previous data to be reused.
 */
export const keepPreviousDataForKey =
  (keyPrefix: QueryKey) =>
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  <T>(previousData: T | undefined, previousQuery?: Query<any, any, any, any>) =>
    previousQuery && matchQuery({ queryKey: keyPrefix }, previousQuery) ? previousData : undefined;
